<template>
  <div>
    <img class="mx-auto p-10" src="@/assets/images/tick.svg"/>
    <h1 class="header-tus text-center text-2xl font-bold py-5">Zahvaljujemo se vam za vašo pomoč</h1>
    <p class="text-center">Skupaj z vami bomo še boljši</p>
    <div v-if="showMore" class="text-center pt-10">
      <div class="pb-5">Preverite aktualno akcijsko ponudbo izdelkov. </div>
      <AppBtn text="Preverite več" @click="openMore"></AppBtn>
    </div>
  </div>
</template>

<script>
import AppBtn from '@/components/AppBtn'

export default {
  name: 'StepThankYou',
  components: { AppBtn },
  props: {
    showMore: {
      default: false
    }
  },
  methods: {
    openMore () {
      window.open('https://www.tus.si/aktualno/akcijska-ponudba/')
    }
  }
}
</script>

<style scoped>

</style>
